import { PayloadAction } from '../../../../../store.model';
import { ActionType } from '../behaviour-selection-dialog.action';
import { BehaviourSelectionDialogState } from '../behaviour-selection-dialog.state';

import { Load, LoadResult } from './load.action';

export function loadReducer(
    state: BehaviourSelectionDialogState,
    action: PayloadAction<ActionType, Load>,
): BehaviourSelectionDialogState {
    return {
        ...state,
        hasPendingData: true,
    };
}

export function loadResultReducer(
    state: BehaviourSelectionDialogState,
    action: PayloadAction<ActionType, LoadResult>,
): BehaviourSelectionDialogState {
    const behaviourTagSelection =
        action.payload.behaviours?.map((e) => ({
            behaviour: e,
            isChecked: action.payload.focuses?.some(
                (ee) => ee.behaviourId === e.id,
            ),
        })) ?? [];

    return {
        ...state,
        behaviourTagSelection,
        hasPendingData: false,
    };
}
